module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/lazarus.a764f66b.png";